import { ASPECT_RATIOS } from '@amp/web-app-components/src/components/Artwork/constants';
import { ArtworkConfig } from '@amp/web-app-components/config/components/artwork';
import type { ArtworkProfileMap } from '@amp/web-app-components/config/components/artwork';

const {
    HD,
    ONE,
    HERO,
    UBER,
    ONE_THIRD,
    EDITORIAL_DEFAULT,
    HD_ASPECT_RATIO,
    VIDEO_TALL,
    THREE_QUARTERS,
    SUPER_HERO_WIDE,
} = ASPECT_RATIOS;

// TODO: evaluate if it makes sense to convert
// from shallow to deep merge for config: rdar://77461236
// (Verify Artwork Profiles are correct at all viewports before launch) rdar://78273625
const PROFILES: ArtworkProfileMap = new Map([
    ['artist-detail-header', [[1200], HD_ASPECT_RATIO, 'mv']],
    ['brick', [[340, 340, 290], HD, 'sr']],
    ['brand-logo', [[80], ONE, 'cc']],
    ['video', [[340, 340, 290, 200], HD, 'mv']],
    ['video-tall', [[340, 340, 290, 200], HD, 'bf']],
    ['playlist-product', [[305, 270, 200], ONE, 'cc']],
    ['product', [[316, 316, 296], ONE, 'bb']],
    ['product-rectangle', [[316, 316, 296], ONE, 'bf']],
    ['product-center-crop', [[316, 316, 296], ONE, 'cc']],
    ['artwork-in-collage', [[200], ONE, 'cc']],
    ['episode', [[790, 525, 330, 295], HD, 'sr']],
    ['episode-tall', [[790, 525, 330, 295], HD, 'bf']],
    ['editorial-card', [[530, 480, 300], EDITORIAL_DEFAULT, 'sr']],
    ['editorial-card-cover-artwork', [[60], ONE, 'cc']],
    ['editorial-card-video-art', [[88], HD_ASPECT_RATIO, 'mv']],
    ['header-lockup', [[500], ONE, 'ea']],
    ['desktop-header-lockup', [[1000], 16 / 8, 'bb']],
    ['hero', [[530, 600, 450], HERO, 'sr']],
    ['icon', [[30], ONE, 'cc']],
    ['uber', [[1200], UBER, 'bb']],
    ['episode-lockup', [[316, 316, 296], ONE, 'cc']],
    ['featured-episode-video', [[320, 260, 211, 176], HD, 'mv']],
    ['horizontal-lockup-video', [[250], HD_ASPECT_RATIO, 'sr']],
    ['top-search-result', [[110], ONE, 'sr']],
    ['top-search-result-video', [[196], HD_ASPECT_RATIO, 'mv']],
    ['top-search-result-poster', [[196], VIDEO_TALL, 'bb']],
    ['ellipse-lockup', [[243, 220, 190, 160], ONE, 'cc']],
    ['standard', [[243, 220, 190, 160], ONE, 'bb']],
    ['powerswoosh', [[300], ONE, 'bb']],
    ['powerswooshTall', [[600, 450], THREE_QUARTERS, 'sr']],
    ['facehole-uber', [[190], ONE, 'cc']],
    ['category-brick', [[520, 340, 290], HD_ASPECT_RATIO, 'sr']],
    ['track-lockup', [[48], ONE, 'bb']],
    ['track-list', [[40], ONE, 'bb']],
    ['track-list-decorated', [[32], ONE, 'bb']],
    ['music-video-tracklist', [[71], HD_ASPECT_RATIO, 'mv']],
    ['superHeroLockup', [[330, 305, 295], THREE_QUARTERS, 'bb']],
    ['social-badge', [[40], ONE, 'cc']],
    ['superHeroTall', [[600, 450], THREE_QUARTERS, 'sr']],
    ['superHeroWide', [[1200, 900, 600, 450], SUPER_HERO_WIDE, 'sr']],
    ['info-fullscreen', [[600, 600, 450], ONE, 'bb']],
    ['miniplayer', [[40], ONE, 'bb']],
]);

ArtworkConfig.set({ PROFILES });
